import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Hidden from '@material-ui/core/Hidden';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import CardSpacer from '../../CardSpacer/CardSpacer';

import styles from './styles.js';
import logo from '../logo.png';

function GlobalDrawer(props) {
  const {
    classes,
    open,
    list,
    toggleDrawer,
    handleLogoClick,
    logoutAction,
  } = props;

  return (
    <div className={`Drawer ${classes.root}`}>
      <Hidden mdUp>
        <SwipeableDrawer
          variant='temporary'
          anchor='left'
          open={open}
          onClose={toggleDrawer}
          onOpen={toggleDrawer}
          onClick={toggleDrawer}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <div className={classes.header}>
            <IconButton
              onClick={toggleDrawer}
              className={classes.closeMenuButton}
            >
              <CloseIcon />
            </IconButton>
            <a
              href='#/'
              onClick={handleLogoClick}
              className={classes.logoContainer}
            >
              <img
                src={logo}
                alt={'MyKāingaOra logo'}
                className={classes.logo}
              />
            </a>
            <Button className={classes.logoutButton} onClick={logoutAction}>
              Logout
            </Button>
          </div>
          {list}
        </SwipeableDrawer>
      </Hidden>
      <Hidden smDown>
        <div className={classes.desktopMenu}>
          <CardSpacer large={true} />
          {list}
        </div>
      </Hidden>
    </div>
  );
}

GlobalDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  open: PropTypes.bool,
  list: PropTypes.element.isRequired,
};

GlobalDrawer.defaultProps = {
  open: false,
};

export default withStyles(styles, { withTheme: true })(GlobalDrawer);
